// Mirrors the legacy inline label logic in ClientDetails report rows,
// extended with lactate-threshold reports (which carry report_category).
export function reportRowLabel(reportType: string, reportCategory?: string): string {
  if (reportCategory === 'lactate_threshold') {
    return reportType === 'Review'
      ? 'Lactate Threshold Review'
      : 'Lactate Threshold Initial';
  }
  if (reportType === 'Foundation_Initial') return 'Foundation Initial Assessment';
  if (reportType === 'Foundation_Review') return 'Foundation Review Assessment';
  if (reportType === 'Initial') return 'Ignition Initial Assessment';
  if (reportType === 'Review') return 'Ignition Review Assessment';
  return `${reportType} Assessment`;
}
